import Tabs from "../../../core/components/Tabs/Tabs";
import React, { useState } from "react";
import { TabType } from "./types/TabType";
import { ResponseApiType } from "../../types/ResponseApiType";
import ApiProvider from "../../../core/api/ApiProvider";
import styles from "./CustomerTransactionTabs.module.scss";
import { Loader, ModuleContainer } from "../../../core/components";
import CustomerTransactionPayments from "./components/CustomerTransactionPayments/CustomerTransactionPayments";
import CustomerTransactionActivities from "./components/CustomerTransactionActivities/CustomerTransactionActivities";
import { AppContext } from "../../../AppContext";
import { useParams } from "react-router-dom";


const CustomerTransactionTabs = () => {
  const context = React.useContext(AppContext);
  const { invoiceNo, creditorNo, accountNo, debtorNo, tenantUId } = useParams() as {
    invoiceNo: string;
    creditorNo: string;
    accountNo: string;
    debtorNo: string;
    tenantUId: string
  };
  const [tabs, setTabs] = useState<TabType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchAvailableTabs = async () => {
    const resultGetAvailableTabs = await ApiProvider.post<ResponseApiType<TabType[]>>(`CustomerTransactionTabsModule/GetAvailableTabs`);

    if (resultGetAvailableTabs.success) {
      const filteredTabs = resultGetAvailableTabs.data.filter((tab) => {
        if (context.isHideMypageCases) {
          if (tab.tabValue === 'payments' || tab.tabValue === 'history') {
            return false;
          }
        }

        return true;
      });

      setTabs(filteredTabs);
    }
    setIsLoading(false);
  };

  const renderModule = (tabName: string) => {
    switch (tabName) {
      case 'payments':
        return <CustomerTransactionPayments />;
      case 'history':
        return <CustomerTransactionActivities />;
      default:
        <>No available module</>;
    }
  };

  React.useEffect(() => {
    fetchAvailableTabs();
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        tabs.length > 0 && (
          <div className="container">
            <ModuleContainer>
              <ModuleContainer.Body variant={ModuleContainer.Body.BodyVariant.Secondary}>
                <Tabs initIndex="0" className={styles.tab}>
                  <Tabs.Nav className={styles.tabNav}>
                    {tabs.map((tab, index) => (
                      <Tabs.Tab
                        key={tab.tabValue}
                        index={`${index}`}
                        className={styles.tabNavItem}
                        classNameActive={styles.tabNavItemActive}
                        label={tab.tabTranslation}
                        component={renderModule(tab.tabValue)}
                      />
                    ))}
                  </Tabs.Nav>

                  <Tabs.Panel className={styles.tabPanel} />
                </Tabs>
              </ModuleContainer.Body>
            </ModuleContainer>
          </div>
        )
      )}
    </>
  );
};

export default CustomerTransactionTabs;
